import React from "react";
import styled from "styled-components";
import JargonOutput from "../../models/JargonOutput";

const JargonParagraph = styled.p` 
    
`;
interface JargonIpsumBoxProps {
    content: JargonOutput | null;
    opacity: number;
    typingText: string;
    isTyping: boolean;
}

const JargonOutputContainer = styled.div<{opacity: number}>`
    padding:55px;
    background-color: white;
    border: 2px solid var(--jargon-secondary);
    box-shadow: var(--box-shadow-depth) var(--box-shadow-depth) 0px 0px var(--jargon-secondary);
    margin-bottom: calc(var(--vertical-spacing) + var(--box-shadow-depth));
    width: 100%;
    min-height: 200px;
    opacity: ${props => props.opacity};
    transition: opacity var(--fade-duration) ease-in-out;
`;

const TypingText = styled.div<{ showCursor: boolean }>`
    white-space: pre-wrap;
    &::after {
        content: '|';
        animation: ${props => props.showCursor ? 'blink 1s infinite' : 'none'};
        opacity: ${props => props.showCursor ? 1 : 0};
        color: var(--jargon-secondary);
    }
    
    @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
    }
`;

const JargonIpsumBox : React.FC<JargonIpsumBoxProps> = ({content, opacity, typingText, isTyping}) => {
    return(
        content && //this is hidden if content is null.
        <JargonOutputContainer opacity={opacity}>
            {isTyping ? (
                <TypingText showCursor={true}>{typingText}</TypingText>
            ) : (
                <TypingText showCursor={false}>
                    {content.paragraphs.join('\n\n')}
                </TypingText>
            )}
        </JargonOutputContainer>
    );
};

export default JargonIpsumBox;